import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { showSessionExpiredModal } from "../slices/authSlice";

const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  },
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {
    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const esgactivites = createApi({
  reducerPath: "esgApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["esg"],
  endpoints: (builder) => ({
    GrigetToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["esg"],
    }),

    Esgreportingperiod: builder.mutation({
      query: ({ token, body }) => {
        return {
          url: `/esg`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
        };
      },
      invalidatesTags: ["esg"],
    }),
    Getesgactivity: builder.query({
      query: ({ token }) => {
        return {
          url: `/esg`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["esg"],
    }),
    Getesdactivityid: builder.query({
      query: ({ id, token }) => {
        return {
          url: `/esg/${id}`,
          header: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    AddesgformItem: builder.mutation({
      query: ({ reportId, token, payload }) => {
        return {
          url: `/esg/${reportId}/esg-item/upsert/`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["esg"],
    }),
    GetesgItemHistory: builder.query({
      query: ({ reportId, token }) => {
        if (!reportId) {
          return;
        }
        return {
          url: `/esg/${reportId}/esg-item/`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["esg"],
    }),
    Deleteesgactivity: builder.mutation({
      query: ({ id, token }) => ({
        url: `/esg/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["esg"],
    }),
    GetBRSRCompanies: builder.query({
      query: () => {
        return {
          url: `/brsr/companies_list`,
        };
      },
    }),
    GetBenchmarkingData: builder.query({
      query: ({ companies }) => ({
        url: `/benchmarking`,
        params: {
          companies: companies.join(","), // e.g., ["Zydus", "Sun Pharma"] → Zydus,Sun Pharma
        },
      }),
    }),

    GetBRSRCompanyMetrics: builder.query({
      query: ({ companyIds, periodStart, periodEnd }) => ({
        url: "/brsr/company_metrics",
        params: {
          company_ids: companyIds.join(","),
          period_start: periodStart,
          period_end: periodEnd,
        },
      }),
    }),
  }),
});

export const {
  useGrigetTokenMutation,
  useGetesgactivityQuery,
  useAddesgformItemMutation,
  useGetesgItemHistoryQuery,
  useEsgreportingperiodMutation,
  useDeleteesgactivityMutation,
  useGetBenchmarkingDataQuery,
  useGetBRSRCompaniesQuery,
  useGetBRSRCompanyMetricsQuery,
} = esgactivites;
